import { t } from "../../i18n";
import { newId } from "@tasduvar/engine";
import { useNavigate } from "react-router-dom";
import { saveNow, useProjectStore } from "../../state/projectStore";
import { cloudStore } from "../../storage";
import { Button } from "../../ui/Button";
import { Dialog } from "../../ui/Dialog";

/** 409: aynı proje başka cihazda değişmiş. Üç seçenek: sunucuyu al, üzerine yaz, kopya olarak sakla. */
export function ConflictDialog(): JSX.Element | null {
  const { project, conflict, openProject, setConflict } = useProjectStore();
  const nav = useNavigate();
  if (!project || !conflict) return null;
  const when = new Date(conflict.server.updatedAt).toLocaleString("tr-TR");
  const takeServer = async (): Promise<void> => {
    const p = await cloudStore.pull(project.id);
    if (p) openProject(p, "cloud"); else setConflict(null);
  };
  const overwrite = async (): Promise<void> => { setConflict(null); await saveNow(undefined, undefined, true); };
  const saveCopy = async (): Promise<void> => {
    const copy = { ...project, id: newId("proj"), info: { ...project.info, name: `${project.info.name} (kopya)` } };
    await cloudStore.save(copy, { force: true });
    const server = await cloudStore.pull(project.id);
    setConflict(null);
    if (server) openProject(server, "cloud");
    openProject(copy, "cloud");
    nav(`/proje/${copy.id}`);
  };
  return (
    <Dialog open onClose={() => undefined} label={t("Proje çakışması")} width={480} tone="warn">
      <h2>{t("Bu proje başka bir cihazda değişmiş")}</h2>
      <p className="text-[11px] text-cad-ink2">{t("Sunucudaki sürüm")} {when} {t("tarihinde kaydedilmiş; sizin değişiklikleriniz onun üzerine yazılmadı.")}</p>
      <div className="grid gap-1.5 justify-items-start">
        <Button onClick={() => void takeServer()}>{t("Sunucuyu al")} <span className="font-normal text-xs opacity-80">{t("— buradaki değişiklikler atılır")}</span></Button>
        <Button variant="danger" onClick={() => void overwrite()}>{t("Üzerine yaz")} <span className="font-normal text-xs opacity-80">{t("— sunucudaki sürüm geçmişe gider")}</span></Button>
        <Button variant="ghost" onClick={() => void saveCopy()}>{t("Kopya olarak sakla")} <span className="font-normal text-xs opacity-80">{t("— ikisi de kalır")}</span></Button>
      </div>
    </Dialog>
  );
}
